import { Component, OnInit } from '@angular/core';
import { AuthService } from '../providers/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { environment } from '../../environments/environment.prod';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.css']
})
export class VerificationComponent implements OnInit {
  private sub:any;
  token:any;
  type:any;
  constructor(private auth: AuthService, private route: ActivatedRoute, private router: Router, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.token = params['token']; // (+) converts string 'id' to a number
      this.type = params['type'];
      // In a real app: dispatch action to load the details here.
      //verify account
      this.spinnerService.show();
      this.auth.verifiysignup({"token":this.token, "type":this.type}).then((user) => {
        let response = user.json();
        this.spinnerService.hide();
        this.auth.open(response.replyMsg);
        this.router.navigateByUrl('/');
      })
      .catch((err) =>{
        this.spinnerService.hide();
        this.auth.open(environment.error);
        this.router.navigateByUrl('/');
      });
   });

   console.log("params",this.sub)
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/verification/verification.component.ts